import PersonOffIcon from '@mui/icons-material/PersonOff';
import SchoolIcon from '@mui/icons-material/School';
import PollIcon from '@mui/icons-material/Poll';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import GroupWorkIcon from '@mui/icons-material/GroupWork';

import GroupIcon from '@mui/icons-material/Group';

export const dashboardIcons = {
  totalEdifiers: { title: 'Total Edifiers', icon: <GroupAddIcon sx={{ fontSize: '30px', color: 'black' }} /> },
  totalMentees: { title: 'Total Teachers', icon: <GroupAddIcon sx={{ fontSize: '30px', color: 'black' }} /> },
  partnerSites: { title: 'Partner Site', icon: <GroupWorkIcon sx={{ fontSize: '30px', color: 'black' }} /> },
  pairedEdifiers: { title: 'Paired Edifiers', icon: <GroupIcon sx={{ fontSize: '30px', color: 'black' }} /> },
  pairedTeacher: { title: 'Paired Teachers', icon: <GroupIcon sx={{ fontSize: '30px', color: 'black' }} /> },
  schools: { title: 'Partner Sites', icon: <SchoolIcon sx={{ fontSize: '30px', color: 'black' }} /> },
  surveyCompletionRate: {
    title: 'Survey Completion Rate (Global)',
    icon: <PollIcon sx={{ fontSize: '30px', color: 'black' }} />,
  },
  surveyCompletionRateSchools: {
    title: 'Survey Completion Rate (Partner Sites)',
    icon: <PollIcon sx={{ fontSize: '30px', color: 'black' }} />,
  },
  surveyCompletionRateCoaches: {
    title: 'Survey Completion Rate (Edifiers)',
    icon: <PollIcon sx={{ fontSize: '30px', color: 'black' }} />,
  },
  surveyCompletionRateSiteLeaders: {
    title: 'Survey Completion Rate (Site Leaders)',
    icon: <PollIcon sx={{ fontSize: '30px', color: 'black' }} />,
  },
  surveyCompletionRateTeachers: {
    title: 'Survey Completion Rate (Teachers)',
    icon: <PollIcon sx={{ fontSize: '30px', color: 'black' }} />,
  },

  unpairedEdifier: { title: 'Unpaired Edifiers', icon: <PersonOffIcon sx={{ fontSize: '30px', color: 'black' }} /> },
  unpairedTeacher: { title: 'Unpaired Teachers', icon: <PersonOffIcon sx={{ fontSize: '30px', color: 'black' }} /> },
};

export const states = [
  // 'Select One',
  'Alabama',
  'Alaska',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'District of Columbia',
  'Florida',
  'Georgia',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Pennsylvania',
  'Puerto Rico',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virgin Islands',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
  'Wyoming',
];

export const teachersOnboardingTextFields = [
  {
    name: 'email',
    type: 'single',
    label: 'Your Email *',
    placeholder: 'abc@abc.com',
  },
  {
    name: 'fname',
    type: 'single',
    label: 'First Name',
    placeholder: 'John',
    // pattern: '[A-Za-z]+',
    // validationLabel: 'Only alphabets are allowed in the first name field',
  },

  {
    name: 'lname',
    type: 'single',
    label: 'Last Name',
    placeholder: 'Doe',
  },

  {
    name: 'currentStatus',
    type: 'multiple',
    label: 'Current Status',
    items: ['Teaching', 'Not Teaching'],
  },
  {
    name: 'totalTeachingExperience',
    type: 'single',
    label: 'Years of Classroom Teaching Experience',
    placeholder: 'Your Answer',
    fieldType: 'number',
  },

  {
    name: 'password',
    type: 'single',
    label: 'Password',
    fieldType: 'password',
  },

  {
    name: 'phone',
    type: 'single',
    label: 'Phone Number',
    fieldType: 'number',
  },
  {
    name: 'gender',
    type: 'multiple',
    label: 'Gender Identity',
    tag: 'Gender',
    items: ['Woman', 'Man', 'Transgender', 'Non-binary/non-conforming', 'Prefer not to respond'],
  },
  {
    name: 'ethnoracially',
    type: 'multiple',
    label: 'How Do You Identify Ethnoracially?',
    tag: 'Ethnoracially Identification',
    items: [
      'African American',
      'American Indian or Alaska Native',
      'Asian',
      'Black',
      'Hispanic/Latino/Latinx',
      'Arab/MENA (Middle Eastern/North African)',
      'Native Hawaiian or Other Pacific Islander',
      'White',
    ],
  },
  {
    name: 'districtSchool',
    type: 'multiple',
    label: 'Which best characterizes your district?',
    requiredLabel: 'District experience Type is required',

    items: [
      // 'Select One',
      'Rural - low resourced',
      'Rural - well resourced',
      'Suburban - low resourced',
      'Suburban - well resourced',
      'Urban - low resourced',
      'Urban - well resourced',
    ],
  },

  // {
  //   name: 'cityCounty',
  //   type: 'multiple',
  //   label: 'City/County',
  //   items: ['milford', 'stamford'],
  // },

  {
    name: 'state',
    requiredLabel: 'District/State is required',
    type: 'multiple',
    label: 'State',
    items: states,
  },

  {
    name: 'cityCounty',
    type: 'multiple',
    label: 'Which best characterizes your district?',
    items: ['Chicago'],
  },

  {
    name: 'programType',
    type: 'multiple',
    label: 'Educator Preparation Program Type',
    items: ['Traditional (4-Year College/University Program)', 'Alternative Certification Program'],

    tag: 'Program Type',
  },
  {
    name: 'institutionType',
    type: 'multiple',
    label: 'What Type of Institution Did you Attend?',
    tag: 'Institution Type',
    items: ['Historically Black College/University (HBCU)', 'Hispanic Serving Institution (HSI)', 'Other'],
  },
  {
    name: 'gradeCurrentlyTeaching',
    type: 'single',
    label: 'Grade Currently Teaching',
    fieldType: 'number',
  },
  {
    name: 'areaTeaching',
    type: 'single',
    label: 'Area(s) of Licensure*',
    placeholder: 'Your Answer',
    validationLabel: 'Area of Licensure is required',
  },

  {
    name: 'contentSpeciality',
    type: 'text',
    label: 'Content Specialty (e.g., which ELA, Math, science, social science, etc. did/do you teach?)*',
    placeholder: 'Your Answer',
    pattern: '[A-Za-z ]+',
    validationLabel: 'Content Specialty is required',
  },

  {
    name: 'certified',
    type: 'single',
    label: 'NBCT Certified or Pursuing NBCT?',
  },
  {
    name: 'interestMotivation',
    type: 'multiLine',
    label: 'What motivates your interest in teaching?',
  },
  {
    name: 'challenges',
    type: 'largeLabel',
    label:
      "We know each person's challenges vary, but what are the key areas that would like to concentrate most on this year with your Edifier mentor?",
    tag: 'Challenges',
  },
  {
    name: 'goals',
    type: 'largeLabel',
    label:
      "In a sentence or less, what if your goal for this year in Edifying Teachers? (This may change over time and you will discuss it with your Edifier in your initial conversations, but we'd love to get a sense of where you are today)",
    tag: 'Goals',
  },
  {
    name: 'availability',
    type: 'single',
    label: 'Availability',
  },

  {
    name: 'currentWork',
    type: 'single',
    label: 'Current Role',
    placeholder: 'Type here...',
  },
  {
    gradesTeaching: [
      '',
      'pre-K',
      'Kindegarten',
      '1st Grade',
      '2nd Grade',
      '3rd Grade',
      '4th Grade',
      '5th Grade',
      '6th Grade',
      '7th Grade',
      '8th grade',
      '9th Grade',
      '10th Grade',
      '11th Grade',
      '12th Grade',
      'Undergrad / Graduate',
    ],
  },

  {
    contentAreaTeaching: [
      '',
      'Career & Tech Education (CTE)',
      'Elementary (Generalist)',
      'English Language Arts',
      'English as a Second Language (ESL)',
      'French',
      'Health',
      'History/Social Studies',
      'Mathematics',
      'Other World Language',
      'Physical Education',
      'Reading',
      'Science',
      'Spanish',
      'Special Education',
      'Technology',
      'Visual & Performing Arts',
    ],
  },
];

export const edifiersOnboardingTextField = [
  {
    name: 'name',
    type: 'single',
    label: 'Full name',
  },
  {
    name: 'email',
    type: 'single',
    label: 'Email Address name',
  },
  {
    name: 'password',
    type: 'single',
    label: 'Password',
    fieldType: 'password',
  },

  {
    name: 'phone',
    type: 'single',
    label: 'Phone Number',
    fieldType: 'number',
  },
  {
    name: 'gender',
    type: 'multiple',
    label: 'Gender',
    tag: 'Gender',
    items: ['Male', 'Female', 'Other'],
  },
  {
    name: 'brief',
    type: 'multiLine',
    label: 'Brief Bio: In 2-3 sentences, give a brief overview of who you are as a prospective teacher mentor.',
    tag: 'Brief Bio about Yourself',
  },
  {
    name: 'location',
    type: 'multiple',
    label: 'Location',
    tag: 'Location',
    items: ['Connecticut'],
  },
  {
    name: 'teachingStatus',
    type: 'multiple',
    label: 'Current Teaching Status',
    tag: 'Current Teaching Status',
    items: ['Teaching', 'Not Teaching'],
  },
  {
    name: 'districtSchool',
    type: 'single',
    label: 'District / School System',
  },
  {
    name: 'totalTeachingExperience',
    type: 'single',
    label: 'Years of Teaching Experience',

    fieldType: 'number',
  },
  {
    name: 'accolades',
    type: 'multiLine',
    label: 'Special Accolades (e.g., Teacher of the Year, etc.)',
    tag: 'Accolades',
    placeholder: 'Your Answer',
  },
  {
    name: 'programType',
    type: 'multiple',
    label: 'Educator Preparation Program Type',
    tag: 'Program Type',
    items: ['Traditional (4-Year College/University Program)', 'Alternative Certification Program'],
  },
  {
    name: 'institutionType',
    type: 'multiple',
    label: 'What Type of Institution Did you Attend?',
    tag: 'Institution Type',
    items: ['Historically Black College/University (HBCU)', 'Hispanic Serving Institution (HSI)', 'Other'],
  },
  {
    name: 'gradeCurrentlyTeaching',
    type: 'single',
    label: 'Grade Currently Teaching',
    fieldType: 'number',
  },
  {
    name: 'areaTeaching',
    type: 'single',
    label: 'Content Area Currently Teaching',
  },
  {
    name: 'certified',
    type: 'single',
    label: 'NBCT Certified or Pursuing NBCT?',
  },
  {
    name: 'interestMotivation',
    type: 'multiLine',
    label: 'What motivates your interest in teaching?',
  },
  {
    name: 'challenges',
    type: 'largeLabel',
    label:
      "We know each person's challenges vary, but what are the key areas that would like to concentrate most on this year with your Edifier mentor?",
    tag: 'Challenges',
  },
  {
    name: 'goals',
    type: 'largeLabel',
    label:
      "In a sentence or less, what if your goal for this year in Edifying Teachers? (This may change over time and you will discuss it with your Edifier in your initial conversations, but we'd love to get a sense of where you are today)",
    tag: 'Goals',
  },
  {
    name: 'availability',
    type: 'single',
    label: 'Availability',
  },
];

export const edifierProfileSocialMediaIcons = [
  { img: '/assets/social/instagram.svg', link: 'https://www.instagram.com/p/Cr2jEwRNzvl/' },
  { img: '/assets/social/linkedIn.svg', link: 'https://www.linkedin.com/company/edifying-teachers' },
  // { img: '/assets/twilio.svg', link: 'https://twitter.com/EdifyTeachers' },
];

export const onBoardingProcessSteps = [
  { title: 'Demographics' },
  { title: 'Professional Experience' },

  { title: "Your Bio, 'Why', & Goal Areas" },
  { title: 'Availability and Preferences' },
  // { title: 'Step 7' },

  // { title: 'Step 3' }
];
export const teachingExperienceItems = ['Currently Teaching', 'Currently Coaching', 'Previously Taught'];

export const surveyItems = ['Strongly Agree', 'Agree', 'Disagree', 'Strongly Disagree'];

export const typesOfResources = ['For Purchase', 'Free'];

export const mockUserData = {
  email: 'johndoe@gmail.net',
  gender: 'male',
  image: null,
  name: 'John Doe',
  phone: '+923000478789',
  role: 'COACH',
  token: null,
};

export const onboardingEarnedDegreesCheckboxData = [
  { label: "Bachelor's Degree", name: 'bachelors' },
  { label: "Master's Degree", name: 'masters' },
  { label: 'Doctorate', name: 'doctorate' },
];
export const programTypeMock = [
  { label: 'Traditional (4-Year College/University Program)', name: 'traditional' },
  { label: 'Alternative Certification Program', name: 'alternative' },
];

export const ethnoracialData = [
  { label: 'African American', name: 'African American' },
  { label: 'American Indian or Alaska Native', name: 'American Indian or Alaska Native' },
  { label: 'Asian', name: 'Asian' },
  { label: 'Black', name: 'Black' },
  { label: 'Hispanic/Latino/Latinx', name: 'Hispanic/Latino/Latinx' },
  { label: 'Arab/MENA (Middle Eastern/North African)', name: 'Arab/MENA (Middle Eastern/North African)' },
  { label: 'Native Hawaiian or Other Pacific Islander', name: 'Native Hawaiian or Other Pacific Islander' },
  { label: 'White', name: 'White' },
];

export const languagesList = [
  'English',
  'Spanish',
  'French',
  'German',
  'Italian',
  'Portuguese',
  'Russian',
  'Chinese (Mandarin)',
  'Chinese (Cantonese)',
  'Japanese',
  'Korean',
  'Arabic',
  'Hindi',
  'Bengali',
  'Urdu',
  'Turkish',
  'Dutch',
  'Swedish',
  'Norwegian',
  'Danish',
  'Finnish',
  'Polish',
  'Czech',
  'Hungarian',
  'Romanian',
  'Bulgarian',
  'Greek',
  'Hebrew',
  'Persian (Farsi)',
  'Thai',
  'Vietnamese',
  'Indonesian',
  'Malay',
  'Tagalog',
  'Swahili',
  'Amharic',
  'Yoruba',
  'Igbo',
  'Hausa',
  'Zulu',
  'Afrikaans',
  'Other'
];

export const institutionDataMocks = [
  { label: 'Historically Black College/University (HBCU)', name: 'hbcu' },
  { label: 'Hispanic Serving Institution (HSI)', name: 'hsi' },
  { label: 'Other', name: 'other' },
];

export const edifyinJourneyTableData = [
  {
    date: 'July 11, 2021',
    summary:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
  },

  {
    date: 'July 12, 2021',
    summary: 'Neque porro quisquam est qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit...',
  },
  {
    date: 'July 13, 2021',
    summary:
      'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
  },
  {
    date: 'July 14, 2021',
    summary:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
  },
  {
    date: 'July 15, 2021',
    summary: 'Neque porro quisquam est qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit...',
  },
];

export const createCoachFormData = [
  {
    name: 'first_name',
    label: 'First Name',
    placeholder: 'John',
  },
  {
    name: 'last_name',
    label: 'Last Name',
    placeholder: 'Doe',
  },

  {
    name: 'email',
    label: 'Email Address',
    placeholder: 'john@example.com',
    type: 'email',
  },

  {
    name: 'password',
    label: 'Password',
    placeholder: '****',
    type: 'password',
  },

  {
    name: 'phone',
    label: 'Phone Number',
    placeholder: '123456789',
  },
];

export const fieldsNotToDisplay = [
  '__v',
  '_id',
  'updatedAt',
  'password',
  'image',
  'createdAt',
  'isVerified',
  'deviceToken',
  'verifyToken',
  'isDeleted',
  'score',
  'Score',
  'assignedTeachers',
  'isAvailable',
  'lastSession',
];
export const fieldsNotToDisplayEdit = [
  '__v',
  '_id',
  'updatedAt',
  'password',
  'image',
  'createdAt',
  'isVerified',
  'email',
];

export const expertiesAndResources = [
  'Afrocentric Education',
  'Assessment',
  'Classroom Management',
  'Cultural Competency',
  'Curriculum',
  'Digital Citizenship',
  'Diversity, Equity, & Inclusion',
  'Family Engagement',
  'Indigenous Education',
  'Instruction',
  'Instructional Technology',
  'Learning Science',
  'Online Assessment',
  'Online Instruction',
  'Professional Learning Community (PLC) Creation & Facilitation',
  'Project-Based Learning',
  'Social-Emotional Learning',
  'Trauma-Informed Teaching',
  'Understanding by Design (UbD)',
  'Other',
  'No Other Expertise'
];

export const typeOfResources = ['', 'Blog Posts', 'Curricular Resources', 'Lesson Plans', 'Podcast Episodes', 'Videos'];

export const nbctCertifiedDropdown = ['Yes', 'No', 'I have started, but not completed the process'];

export const termsOfInterestMocks = [
  'Baltimore, MD-Asynchronous Virtual Mentoring',
  'Baltimore, MD-Monthly In-Person Group Sessions',
  'Ector County, TX--Asynchronous Virtual Mentoring',
  'Ector County TX-Monthly In-Person Group Sessions',
];

export const huddleWorkItems = [
  { label: 'Weekday Early Morning', value: 'weekday-early-morning' },
  { label: 'Weekday During the School Day', value: 'weekday-school-day' },
  { label: 'Weekday Evening', value: 'weekday-evening' },
  { label: 'Weekend Afternoon', value: 'weekend-afternoon' },
];

export const preferredMethodOfCommunication = ['E-mail', 'Phone Call', 'Social Media Platform', 'Text'];

export const svgPaths = [
  {
    d: 'M20.0423 9.65227C23.5563 3.34837 25.3132 0.196411 27.9402 0.196411C30.5672 0.196411 32.3242 3.34834 35.8381 9.65224L36.7472 11.2831C37.746 13.0745 38.2451 13.9702 39.0238 14.5612C39.8023 15.1522 40.7716 15.3715 42.7109 15.8103L44.4764 16.2097C51.3001 17.7537 54.7122 18.5257 55.5239 21.136C56.3357 23.7463 54.0097 26.4665 49.3575 31.9063L48.154 33.3137C46.8321 34.8596 46.171 35.6325 45.8736 36.5888C45.5764 37.5451 45.6763 38.5763 45.876 40.639L46.058 42.5166C46.7613 49.7747 47.1131 53.4038 44.988 55.0171C42.8626 56.6303 39.668 55.1594 33.2788 52.2178L31.6259 51.4565C29.8104 50.6206 28.9026 50.2025 27.9402 50.2025C26.9778 50.2025 26.0701 50.6206 24.2546 51.4565L22.6016 52.2178C16.2124 55.1594 13.0178 56.6303 10.8926 55.0171C8.7674 53.4038 9.11907 49.7747 9.82241 42.5166L10.0043 40.639C10.2042 38.5763 10.3042 37.5451 10.0068 36.5888C9.70944 35.6325 9.04847 34.8596 7.72649 33.3137L6.52294 31.9063C1.87086 26.4665 -0.455188 23.7463 0.356571 21.136C1.16833 18.5257 4.58027 17.7537 11.4041 16.2097L13.1696 15.8103C15.1087 15.3715 16.0783 15.1522 16.8567 14.5612C17.6352 13.9702 18.1346 13.0745 19.1331 11.2831L20.0423 9.65227Z',
    fill: '#F68901',
    x: 55,
  },
  {
    d: 'M115.073 9.65227C118.587 3.34837 120.344 0.196411 122.971 0.196411C125.597 0.196411 127.354 3.34834 130.868 9.65224L131.778 11.2831C132.776 13.0745 133.275 13.9702 134.054 14.5612C134.833 15.1522 135.802 15.3715 137.741 15.8103L139.507 16.2097C146.33 17.7537 149.742 18.5257 150.554 21.136C151.366 23.7463 149.04 26.4665 144.388 31.9063L143.184 33.3137C141.862 34.8596 141.201 35.6325 140.904 36.5888C140.607 37.5451 140.707 38.5763 140.906 40.639L141.088 42.5166C141.792 49.7747 142.143 53.4038 140.018 55.0171C137.893 56.6303 134.698 55.1594 128.309 52.2178L126.656 51.4565C124.841 50.6206 123.933 50.2025 122.971 50.2025C122.008 50.2025 121.1 50.6206 119.285 51.4565L117.632 52.2178C111.243 55.1594 108.048 56.6303 105.923 55.0171C103.798 53.4038 104.149 49.7747 104.853 42.5166L105.035 40.639C105.235 38.5763 105.334 37.5451 105.037 36.5888C104.74 35.6325 104.079 34.8596 102.757 33.3137L101.553 31.9063C96.9011 26.4665 94.5751 23.7463 95.3868 21.136C96.1986 18.5257 99.6105 17.7537 106.434 16.2097L108.2 15.8103C110.139 15.3715 111.109 15.1522 111.887 14.5612C112.666 13.9702 113.165 13.0745 114.163 11.2831L115.073 9.65227Z',
    fill: '#F68901',
    x: 81,
  },
  {
    d: 'M210.103 9.65227C213.617 3.34837 215.374 0.196411 218.001 0.196411C220.628 0.196411 222.385 3.34834 225.899 9.65224L226.808 11.2831C227.807 13.0745 228.306 13.9702 229.084 14.5612C229.863 15.1522 230.832 15.3715 232.771 15.8103L234.537 16.2097C241.361 17.7537 244.773 18.5257 245.584 21.136C246.396 23.7463 244.07 26.4665 239.418 31.9063L238.215 33.3137C236.893 34.8596 236.232 35.6325 235.934 36.5888C235.637 37.5451 235.737 38.5763 235.937 40.639L236.119 42.5166C236.822 49.7747 237.174 53.4038 235.049 55.0171C232.923 56.6303 229.729 55.1594 223.339 52.2178L221.686 51.4565C219.871 50.6206 218.963 50.2025 218.001 50.2025C217.038 50.2025 216.131 50.6206 214.315 51.4565L212.662 52.2178C206.273 55.1594 203.078 56.6303 200.953 55.0171C198.828 53.4038 199.18 49.7747 199.883 42.5166L200.065 40.639C200.265 38.5763 200.365 37.5451 200.067 36.5888C199.77 35.6325 199.109 34.8596 197.787 33.3137L196.583 31.9063C191.931 26.4665 189.605 23.7463 190.417 21.136C191.229 18.5257 194.641 17.7537 201.465 16.2097L203.23 15.8103C205.169 15.3715 206.139 15.1522 206.917 14.5612C207.696 13.9702 208.195 13.0745 209.194 11.2831L210.103 9.65227Z',
    fill: '#F68901',
    x: 87,
  },
  {
    d: 'M305.132 9.65227C308.646 3.34837 310.403 0.196411 313.03 0.196411C315.657 0.196411 317.414 3.34834 320.928 9.65224L321.837 11.2831C322.836 13.0745 323.335 13.9702 324.114 14.5612C324.892 15.1522 325.861 15.3715 327.801 15.8103L329.566 16.2097C336.39 17.7537 339.802 18.5257 340.614 21.136C341.426 23.7463 339.1 26.4665 334.447 31.9063L333.244 33.3137C331.922 34.8596 331.261 35.6325 330.963 36.5888C330.666 37.5451 330.766 38.5763 330.966 40.639L331.148 42.5166C331.851 49.7747 332.203 53.4038 330.078 55.0171C327.952 56.6303 324.758 55.1594 318.369 52.2178L316.716 51.4565C314.9 50.6206 313.992 50.2025 313.03 50.2025C312.068 50.2025 311.16 50.6206 309.344 51.4565L307.691 52.2178C301.302 55.1594 298.108 56.6303 295.982 55.0171C293.857 53.4038 294.209 49.7747 294.912 42.5166L295.094 40.639C295.294 38.5763 295.394 37.5451 295.097 36.5888C294.799 35.6325 294.138 34.8596 292.816 33.3137L291.613 31.9063C286.961 26.4665 284.635 23.7463 285.446 21.136C286.258 18.5257 289.67 17.7537 296.494 16.2097L298.259 15.8103C300.199 15.3715 301.168 15.1522 301.947 14.5612C302.725 13.9702 303.224 13.0745 304.223 11.2831L305.132 9.65227Z',
    fill: '#F68901',
    x: 89,
  },
  {
    d: 'M416.431 11.5266L416.431 11.5266L415.521 9.89569L415.958 9.65224L415.521 9.89568C413.756 6.72912 412.459 4.40438 411.28 2.86436C410.101 1.32467 409.134 0.696411 408.06 0.696411C406.987 0.696411 406.02 1.32467 404.841 2.86438C403.662 4.40441 402.364 6.72916 400.599 9.89572L399.69 11.5266C399.669 11.5643 399.648 11.6016 399.628 11.6386C398.689 13.3223 398.142 14.3046 397.279 14.9594C396.414 15.6164 395.344 15.8584 393.523 16.2702C393.482 16.2793 393.441 16.2886 393.4 16.298L391.635 16.6974C388.206 17.4732 385.692 18.0434 383.929 18.7382C382.176 19.4293 381.293 20.1945 380.954 21.2845L380.477 21.1362L380.954 21.2845C380.613 22.3799 380.9 23.5512 381.934 25.1937C382.971 26.8416 384.686 28.8489 387.023 31.5814L386.674 31.8795L387.023 31.5814L388.227 32.9888L388.305 33.0804C389.552 34.5381 390.276 35.385 390.604 36.4403C390.932 37.4936 390.823 38.6196 390.634 40.5654L390.622 40.6872L390.44 42.5649C390.087 46.21 389.829 48.8892 389.916 50.8614C390.004 52.8328 390.434 53.95 391.315 54.6188C392.188 55.2814 393.32 55.3637 395.13 54.8448C396.948 54.3242 399.302 53.2418 402.513 51.7636C402.513 51.7636 402.513 51.7636 402.513 51.7636L404.166 51.0024L404.166 51.0024L404.286 50.9469C405.986 50.164 406.988 49.7025 408.06 49.7025C409.133 49.7025 410.135 50.164 411.835 50.9469L411.955 51.0024L411.955 51.0024L413.608 51.7636C416.819 53.2418 419.173 54.3242 420.99 54.8448C422.801 55.3637 423.933 55.2815 424.806 54.6188C425.687 53.95 426.116 52.8328 426.204 50.8614C426.292 48.8892 426.034 46.21 425.68 42.5649L425.498 40.6872L425.487 40.5653C425.298 38.6195 425.189 37.4937 425.516 36.4404L425.516 36.4403C425.844 35.3853 426.569 34.5385 427.815 33.0815L427.894 32.9888L429.098 31.5814L429.468 31.8982L429.098 31.5814C431.434 28.8489 433.149 26.8416 434.187 25.1937C435.221 23.5513 435.507 22.3799 435.167 21.2845L435.644 21.136L435.167 21.2845C434.828 20.1945 433.945 19.4293 432.191 18.7382C430.428 18.0434 427.915 17.4732 424.486 16.6974L422.721 16.298L422.598 16.2703C420.777 15.8584 419.707 15.6165 418.842 14.9595L416.431 11.5266ZM416.431 11.5266L416.495 11.6419M416.431 11.5266L416.495 11.6419M416.495 11.6419C417.432 13.3235 417.979 14.305 418.842 14.9594L416.495 11.6419Z',
    fill: '#F68901',
    stroke: '#F68901',
  },
];

export const teachingInfoInEdifiersCase = {
  'pre-K': { teaching: false, coaching: false, prevTaught: false },
  Kindegarten: { teaching: false, coaching: false, prevTaught: false },
  '1st Grade': { teaching: false, coaching: false, prevTaught: false },
  '2nd Grade': { teaching: false, coaching: false, prevTaught: false },
  '3rd Grade': { teaching: false, coaching: false, prevTaught: false },
  '4th Grade': { teaching: false, coaching: false, prevTaught: false },
  '5th Grade': { teaching: false, coaching: false, prevTaught: false },
  '6th Grade': { teaching: false, coaching: false, prevTaught: false },
  '7th Grade': { teaching: false, coaching: false, prevTaught: false },
  '8th grade': { teaching: false, coaching: false, prevTaught: false },
  '9th Grade': { teaching: false, coaching: false, prevTaught: false },
  '10th Grade': { teaching: false, coaching: false, prevTaught: false },
  '11th Grade': { teaching: false, coaching: false, prevTaught: false },
  '12th Grade': { teaching: false, coaching: false, prevTaught: false },
  'Undergrad / Graduate': { teaching: false, coaching: false, prevTaught: false },
};

export const surveyCSection1 = {
  'We have revisited my goals to update them and to reflect on what I have already accomplished.': {
    teaching: false,
    coaching: false,
    prevTaught: false,
  },
  'I can identify resources for my classroom.': { teaching: false, coaching: false, prevTaught: false },
  'I am more aware of my strengths and areas for growth as a result of this work.': {
    teaching: false,
    coaching: false,
    'This work has helped me identify soft spaces to land and  sustain my work.': false,
  },
};

export const teachingInfoInTeachersCase = {
  'pre-K': { teaching: false },
  Kindegarten: { teaching: false },
  '1st Grade': { teaching: false },
  '2nd Grade': { teaching: false },
  '3rd Grade': { teaching: false },
  '4th Grade': { teaching: false },
  '5th Grade': { teaching: false },
  '6th Grade': { teaching: false },
  '7th Grade': { teaching: false },
  '8th grade': { teaching: false },
  '9th Grade': { teaching: false },
  '10th Grade': { teaching: false },
  '11th Grade': { teaching: false },
  '12th Grade': { teaching: false },
  'Undergrad / Graduate': { teaching: false },
};

export const contentAreaEdifiersCase = {
  'Career & Tech Education (CTE)': { teaching: false, coaching: false, prevTaught: false },
  'Elementary (Generalist)': { teaching: false, coaching: false, prevTaught: false },
  'English Language Arts': { teaching: false, coaching: false, prevTaught: false },
  'English as a Second Language (ESL)': { teaching: false, coaching: false, prevTaught: false },
  French: { teaching: false, coaching: false, prevTaught: false },
  Health: { teaching: false, coaching: false, prevTaught: false },
  'History/Social Studies': { teaching: false, coaching: false, prevTaught: false },
  Mathematics: { teaching: false, coaching: false, prevTaught: false },
  'Other World Language': { teaching: false, coaching: false, prevTaught: false },
  'Physical Education': { teaching: false, coaching: false, prevTaught: false },
  Reading: { teaching: false, coaching: false, prevTaught: false },
  Science: { teaching: false, coaching: false, prevTaught: false },
  Spanish: { teaching: false, coaching: false, prevTaught: false },
  'Special Education': { teaching: false, coaching: false, prevTaught: false },
  Technology: { teaching: false, coaching: false, prevTaught: false },
  'Visual & Performing Arts': { teaching: false, coaching: false, prevTaught: false },
};

export const contentAreaTeachersCase = {
  'Career & Tech Education (CTE)': { teaching: false },
  'Elementary (Generalist)': { teaching: false },
  'English Language Arts': { teaching: false },
  'English as a Second Language (ESL)': { teaching: false },
  French: { teaching: false },
  Health: { teaching: false },
  'History/Social Studies': { teaching: false },
  Mathematics: { teaching: false },
  'Other World Language': { teaching: false },
  'Physical Education': { teaching: false },
  Reading: { teaching: false },
  Science: { teaching: false },
  Spanish: { teaching: false },
  'Special Education': { teaching: false },
  Technology: { teaching: false },
  'Visual & Performing Arts': { teaching: false },
};

export const onboardingStepsContent = {
  introText:
    ' Thank you for your dedication to the teaching profession and your interest in supporting new teachers in our growing community. Please tell us a bit more about your background, so we can help find the best opportunities for you to maximize your reach and impact, based on your experience, expertise, interests, and preferences.',
};

export const seperateBoolValues = [
  'ethnoRacial',
  'languagesSpoken',
  'degrees',
  'educatorProgramType',
  'institution',
  'teaching',
  'contentAreaTeaching',
  'contentAreaTeachingExperience',
  'ifRetired',
  'expertiesAndResources',
  'typesOfResources',
  'termsOfInterest',
  'regionalHuddleWork',
  'preferredMethodOfCommunication',
];

export const surveyQuestions = [
  'Questions',
  'We have revisited my goals to update them and to reflect on what I have already accomplished.',
  'I can identify resources for my classroom.',
  'I am more aware of my strengths and areas for growth as a result of this work.',
  'This work has helped me identify soft spaces to land and  sustain my work.',
];
export const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// surveys related data
export const survey1Items = ['Modeling', 'Mentoring', 'Mindset', 'Mastering'];

export const survey1SecondItems = [
  'Collaboration with connection to resource/person(s)',
  'Culturally sustaining conversation',
  'Career Navigation',
];

export const welcomeSessionSurveyHeadItems = [
  '',
  { name: 'enjoyedSession', title: 'I enjoyed the session.' },
  { name: 'lookForwardToNext', title: 'I look forward to the next session.' },
  { name: 'workingWithThisEdifier', title: 'I think I will like working with this Edifier.' },
  { name: 'howWillImproveMyTeaching', title: 'I can see how this will help me improve my teaching.' },
];
export const welcomeSessionSurveyItems = ['Strongly Agree', 'Agree', 'Disagree', 'Strongly Disagree'];

export const sessionASurveyHeadItems = [
  '',
  { title: 'My Edifier is well-prepared for our sessions.', name: 'edifierWellPrepared' },
  { title: 'The tempo and flow of the session feels right.', name: 'tempoAndFlowFeelsRight' },
  { title: 'I am getting practical advice I can use in my classroom.', name: 'gettingPracticalAdvice' },
  { title: 'We have identified resources for me to use (SL , LT)', name: 'identifiedResourcesSlLt' },
  { title: 'I feel supported by my edifier', name: 'feelsSupported' },
];
export const sessionBSurveyHeadItems = [
  '',
  { title: 'My goals are being addressed in our sessions.', name: 'goalsBeingAddressed' },
  { title: 'We have identified new strategies for me to use.', name: 'identifiedNewStrategies' },
  { title: 'Occasionally my questions were not answered in the session.', name: 'ocassionallyQuestionsNotAnswered' },
  { title: 'I am a better teacher as a result of this work.', name: 'betterTeacherAsaResult' },
  { title: 'We are addressing my identified goals', name: 'addressingIdentifiedGoals' },
];
export const sessionCSurveyHeadItems = [
  '',
  {
    title: 'We have revisited my goals to update them and to reflect on what I have already accomplished.',
    name: 'revisitedReflectedOnAcomplishedGoals',
  },
  { title: 'I can identify resources for my classroom.', name: 'canIdentifyResourcesForClassroom' },
  {
    title: 'I am more aware of my strengths and areas for growth as a result of this work.',
    name: 'moreAwareOfStrengthsAndAreas',
  },
  {
    title: 'This work has helped me identify soft spaces to land and  sustain my work.',
    name: 'helpedIdentifySoftspacesAndSustainWork',
  },
  { title: 'We are addressing my identified goals', name: 'addressingGoals' },

  { title: 'I now feel connected with the teacher community', name: 'feelConnectedWithCommunity' },
];
export const finalSurveyHeadItems = [
  '',
  {
    title: 'My Edifier has made me aware of my strengths and areas for growth as a teacher.',
    name: 'madeMeAwareOfStengthsAndAreas',
  },
  { title: 'I understand instruction strategies better', name: 'understandStrategiesBetter' },
  { title: 'I use new instruction strategies in my class.', name: 'usedNewInstructionStrategies' },
  {
    title: 'I look forward to being an important leader in the education community.',
    name: 'lookForwardToBeingAnImportantLeader',
  },
];

export const finalSessionSurveyItems = [
  { title: 'reducedStress', description: 'reduced my stress' },
  { title: 'depeenedMySense', description: 'deepened my sense of belonging in the field' },
  { title: 'providedEmotionalSupport', description: 'provided emotional support' },
  { title: 'connectedOtherTeachers', description: 'connected me to other teachers' },
  { title: 'madeFeelSeen', description: 'made me feel seen' },
  { title: 'madeFeelHeard', description: 'made me feel heard' },
  { title: 'madeFeelNurtured', description: 'made me feel nurtured' },
  { title: 'helpedEstablishANetwork', description: 'helped me establish a network' },
  { title: 'increasedSkills', description: 'increased my skills' },
  { title: 'strategiesToConnectWithFamilies', description: 'provided strategies to connect with families' },
  { title: 'providedSomeoneToTalk', description: 'provided someone to talk to' },
  { title: 'helpedAdvocateForMyself', description: 'helped me advocate for myself' },
  { title: 'helpedAdvocateForStudents', description: 'helped me advocate for my students' },
  { title: 'connectedToImportantResources', description: 'connected me to important resources' },
  { title: 'providedIntructionalSupport', description: 'provided instructional support' },
];

// surveys related data

// social Media Icons

export const socialMediaIcons = [
  { icon: '/assets/coachProfileIcons/coachProfileInsta.svg', link: '' },
  { icon: '/assets/coachProfileIcons/coachProfileLinkedIn.svg', link: '' },
  { icon: '/assets/coachProfileIcons/coachProfileTwillio.svg', link: '' },
];
// social Media Icons

export const partnerAffiliationSchoolItems = [
  'Association of International Educators and Leaders of Color (AIELOC)',
  'He Is Me Institute',
  'Latinos for Education',
  'Latinx Education Collaborative',
  'UpLiFT Movement',
  'I am not affiliated with any mentorship partners',
  'Other',
];

export const columnsToAddMarkerOn = ['name', 'Edifier Name', 'Teacher Name'];

export const raceDisplayNames = {
  americanIndianOrAlNative: 'American Indian or Alaska Native',
  africanAmerican: 'African American',
  africafnAmerican: 'African American',
  asian: 'Asian',

  white: 'White',

  arabMena: 'Arab/Mena',
  nHawaiianOrPacificIslander: 'Native Hawaiian or Pacific Islander',
  black: 'Black',
  hispantoLatinLatinX: 'Hispanic/Latino/Latinx',
};
